import { render, staticRenderFns } from "./ClientLicenseSelection.vue?vue&type=template&id=3e952e54&"
import script from "./ClientLicenseSelection.vue?vue&type=script&lang=js&"
export * from "./ClientLicenseSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports